import { useEffect, useState } from 'react';
import { useWindowSizeNoTimeout } from '../UseWindowSizeNoTimeout';

export const useMobileTabletDesktop = (): string => {
  const [windowWidth] = useWindowSizeNoTimeout();
  const [device, setDevice] = useState(null);

  useEffect(() => {
    if (windowWidth > 0 && windowWidth <= 752) {
      setDevice('mobile');
    }

    if (windowWidth >= 753 && windowWidth < 1179) {
      setDevice('tablet');
    }

    if (windowWidth >= 1180) {
      setDevice('desktop');
    }
  }, [windowWidth]);

  return device;
};
